module.exports = __webpack_public_path__ + "img/小暑详情.2b5314c2.jpg";